import _definePage_default_0 from '/app/src/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/app/src/pages/apps/analytics.vue?definePage&vue'
import _definePage_default_3 from '/app/src/pages/apps/calendar.vue?definePage&vue'
import _definePage_default_4 from '/app/src/pages/itineraries/updates/committee/comparison.vue?definePage&vue'
import _definePage_default_5 from '/app/src/pages/login.vue?definePage&vue'
import _definePage_default_6 from '/app/src/pages/not-authorized.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/app/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/administrative',
    /* internal name: 'administrative' */
    /* no component */
    children: [
      {
        path: 'access-profiles',
        /* internal name: 'administrative-access-profiles' */
        /* no component */
        children: [
          {
            path: '',
            name: 'administrative-access-profiles',
            component: () => import('/app/src/pages/administrative/access-profiles/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'course-plan-templates',
        /* internal name: 'administrative-course-plan-templates' */
        /* no component */
        children: [
          {
            path: '',
            name: 'administrative-course-plan-templates',
            component: () => import('/app/src/pages/administrative/course-plan-templates/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'administrative-course-plan-templates-id',
            component: () => import('/app/src/pages/administrative/course-plan-templates/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'management',
        /* internal name: 'administrative-management' */
        /* no component */
        children: [
          {
            path: '',
            name: 'administrative-management',
            component: () => import('/app/src/pages/administrative/management/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'suggestions',
        /* internal name: 'administrative-suggestions' */
        /* no component */
        children: [
          {
            path: '',
            name: 'administrative-suggestions',
            component: () => import('/app/src/pages/administrative/suggestions/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'users',
        /* internal name: 'administrative-users' */
        /* no component */
        children: [
          {
            path: '',
            name: 'administrative-users',
            component: () => import('/app/src/pages/administrative/users/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'administrative-users-id',
            component: () => import('/app/src/pages/administrative/users/[id].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/apps',
    /* internal name: 'apps' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'analytics',
        name: 'apps-analytics',
        component: () => import('/app/src/pages/apps/analytics.vue'),
        /* no children */
      },
  _definePage_default_2
  ),
      {
        path: 'analytics-old',
        name: 'apps-analytics-old',
        component: () => import('/app/src/pages/apps/analytics-old.vue'),
        /* no children */
      },
  _mergeRouteRecord(
      {
        path: 'calendar',
        name: 'apps-calendar',
        component: () => import('/app/src/pages/apps/calendar.vue'),
        /* no children */
      },
  _definePage_default_3
  ),
      {
        path: 'calendar-old',
        name: 'apps-calendar-old',
        component: () => import('/app/src/pages/apps/calendar-old.vue'),
        /* no children */
      },
      {
        path: 'contact',
        name: 'apps-contact',
        component: () => import('/app/src/pages/apps/contact.vue'),
        /* no children */
      },
      {
        path: 'faq',
        name: 'apps-faq',
        component: () => import('/app/src/pages/apps/faq.vue'),
        /* no children */
      },
      {
        path: 'faq-old',
        name: 'apps-faq-old',
        component: () => import('/app/src/pages/apps/faq-old.vue'),
        /* no children */
      },
      {
        path: 'manage-account',
        /* internal name: 'apps-manage-account' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-manage-account',
            component: () => import('/app/src/pages/apps/manage-account/index.vue'),
            /* no children */
          },
          {
            path: 'account-details',
            /* internal name: 'apps-manage-account-account-details' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-manage-account-account-details',
                component: () => import('/app/src/pages/apps/manage-account/account-details/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'biography',
            /* internal name: 'apps-manage-account-biography' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-manage-account-biography',
                component: () => import('/app/src/pages/apps/manage-account/biography/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'social-details',
            /* internal name: 'apps-manage-account-social-details' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-manage-account-social-details',
                component: () => import('/app/src/pages/apps/manage-account/social-details/index.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'notifications',
        name: 'apps-notifications',
        component: () => import('/app/src/pages/apps/notifications.vue'),
        /* no children */
      },
      {
        path: 'notifications-old',
        name: 'apps-notifications-old',
        component: () => import('/app/src/pages/apps/notifications-old.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/blank',
    name: 'blank',
    component: () => import('/app/src/pages/blank.vue'),
    /* no children */
  },
  {
    path: '/itineraries',
    /* internal name: 'itineraries' */
    /* no component */
    children: [
      {
        path: 'areas',
        /* internal name: 'itineraries-areas' */
        /* no component */
        children: [
          {
            path: '',
            name: 'itineraries-areas',
            component: () => import('/app/src/pages/itineraries/areas/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'itineraries-areas-id',
            component: () => import('/app/src/pages/itineraries/areas/[id].vue'),
            /* no children */
          },
          {
            path: 'history',
            /* internal name: 'itineraries-areas-history' */
            /* no component */
            children: [
              {
                path: '',
                name: 'itineraries-areas-history',
                component: () => import('/app/src/pages/itineraries/areas/history/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'improvements',
            /* internal name: 'itineraries-areas-improvements' */
            /* no component */
            children: [
              {
                path: '',
                name: 'itineraries-areas-improvements',
                component: () => import('/app/src/pages/itineraries/areas/improvements/index.vue'),
                /* no children */
              },
              {
                path: ':id',
                name: 'itineraries-areas-improvements-id',
                component: () => import('/app/src/pages/itineraries/areas/improvements/[id].vue'),
                /* no children */
              },
              {
                path: 'acquirements',
                name: 'itineraries-areas-improvements-acquirements',
                component: () => import('/app/src/pages/itineraries/areas/improvements/acquirements.vue'),
                /* no children */
              },
              {
                path: 'basic-capabilities',
                name: 'itineraries-areas-improvements-basic-capabilities',
                component: () => import('/app/src/pages/itineraries/areas/improvements/basic-capabilities.vue'),
                /* no children */
              },
              {
                path: 'functions',
                name: 'itineraries-areas-improvements-functions',
                component: () => import('/app/src/pages/itineraries/areas/improvements/functions.vue'),
                /* no children */
              },
              {
                path: 'related-occupations',
                name: 'itineraries-areas-improvements-related-occupations',
                component: () => import('/app/src/pages/itineraries/areas/improvements/related-occupations.vue'),
                /* no children */
              },
              {
                path: 'technical-capabilities',
                name: 'itineraries-areas-improvements-technical-capabilities',
                component: () => import('/app/src/pages/itineraries/areas/improvements/technical-capabilities.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'occupations',
            /* internal name: 'itineraries-areas-occupations' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'itineraries-areas-occupations-id',
                component: () => import('/app/src/pages/itineraries/areas/occupations/[id].vue'),
                /* no children */
              },
              {
                path: 'curricular-organization',
                /* internal name: 'itineraries-areas-occupations-curricular-organization' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'itineraries-areas-occupations-curricular-organization',
                    component: () => import('/app/src/pages/itineraries/areas/occupations/curricular-organization/index.vue'),
                    /* no children */
                  },
                  {
                    path: 'module',
                    /* internal name: 'itineraries-areas-occupations-curricular-organization-module' */
                    /* no component */
                    children: [
                      {
                        path: 'curricular-unit',
                        /* internal name: 'itineraries-areas-occupations-curricular-organization-module-curricular-unit' */
                        /* no component */
                        children: [
                          {
                            path: ':id',
                            name: 'itineraries-areas-occupations-curricular-organization-module-curricular-unit-id',
                            component: () => import('/app/src/pages/itineraries/areas/occupations/curricular-organization/module/curricular-unit/[id].vue'),
                            /* no children */
                          },
                          {
                            path: 'basic-capabilities',
                            name: 'itineraries-areas-occupations-curricular-organization-module-curricular-unit-basic-capabilities',
                            component: () => import('/app/src/pages/itineraries/areas/occupations/curricular-organization/module/curricular-unit/basic-capabilities.vue'),
                            /* no children */
                          },
                          {
                            path: 'pedagogical-environments',
                            name: 'itineraries-areas-occupations-curricular-organization-module-curricular-unit-pedagogical-environments',
                            component: () => import('/app/src/pages/itineraries/areas/occupations/curricular-organization/module/curricular-unit/pedagogical-environments.vue'),
                            /* no children */
                          },
                          {
                            path: 'technical-capabilities',
                            name: 'itineraries-areas-occupations-curricular-organization-module-curricular-unit-technical-capabilities',
                            component: () => import('/app/src/pages/itineraries/areas/occupations/curricular-organization/module/curricular-unit/technical-capabilities.vue'),
                            /* no children */
                          }
                        ],
                      }
                    ],
                  }
                ],
              },
              {
                path: 'participants',
                name: 'itineraries-areas-occupations-participants',
                component: () => import('/app/src/pages/itineraries/areas/occupations/participants.vue'),
                /* no children */
              },
              {
                path: 'work-context',
                /* internal name: 'itineraries-areas-occupations-work-context' */
                /* no component */
                children: [
                  {
                    path: 'evolution',
                    name: 'itineraries-areas-occupations-work-context-evolution',
                    component: () => import('/app/src/pages/itineraries/areas/occupations/work-context/evolution.vue'),
                    /* no children */
                  },
                  {
                    path: 'means-of-productions',
                    name: 'itineraries-areas-occupations-work-context-means-of-productions',
                    component: () => import('/app/src/pages/itineraries/areas/occupations/work-context/means-of-productions.vue'),
                    /* no children */
                  },
                  {
                    path: 'related-professions',
                    name: 'itineraries-areas-occupations-work-context-related-professions',
                    component: () => import('/app/src/pages/itineraries/areas/occupations/work-context/related-professions.vue'),
                    /* no children */
                  },
                  {
                    path: 'working-conditions',
                    name: 'itineraries-areas-occupations-work-context-working-conditions',
                    component: () => import('/app/src/pages/itineraries/areas/occupations/work-context/working-conditions.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'professional-initiations',
            /* internal name: 'itineraries-areas-professional-initiations' */
            /* no component */
            children: [
              {
                path: '',
                name: 'itineraries-areas-professional-initiations',
                component: () => import('/app/src/pages/itineraries/areas/professional-initiations/index.vue'),
                /* no children */
              },
              {
                path: ':id',
                name: 'itineraries-areas-professional-initiations-id',
                component: () => import('/app/src/pages/itineraries/areas/professional-initiations/[id].vue'),
                /* no children */
              },
              {
                path: 'acquirements',
                name: 'itineraries-areas-professional-initiations-acquirements',
                component: () => import('/app/src/pages/itineraries/areas/professional-initiations/acquirements.vue'),
                /* no children */
              },
              {
                path: 'basic-capabilities',
                name: 'itineraries-areas-professional-initiations-basic-capabilities',
                component: () => import('/app/src/pages/itineraries/areas/professional-initiations/basic-capabilities.vue'),
                /* no children */
              },
              {
                path: 'functions',
                name: 'itineraries-areas-professional-initiations-functions',
                component: () => import('/app/src/pages/itineraries/areas/professional-initiations/functions.vue'),
                /* no children */
              },
              {
                path: 'related-occupations',
                name: 'itineraries-areas-professional-initiations-related-occupations',
                component: () => import('/app/src/pages/itineraries/areas/professional-initiations/related-occupations.vue'),
                /* no children */
              },
              {
                path: 'technical-capabilities',
                name: 'itineraries-areas-professional-initiations-technical-capabilities',
                component: () => import('/app/src/pages/itineraries/areas/professional-initiations/technical-capabilities.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'reports',
        /* internal name: 'itineraries-reports' */
        /* no component */
        children: [
          {
            path: '',
            name: 'itineraries-reports',
            component: () => import('/app/src/pages/itineraries/reports/index.vue'),
            /* no children */
          },
          {
            path: 'forms',
            /* internal name: 'itineraries-reports-forms' */
            /* no component */
            children: [
              {
                path: 'CoursesByModalityAndAreaReportForm',
                name: 'itineraries-reports-forms-courses-by-modality-and-area-report-form',
                component: () => import('/app/src/pages/itineraries/reports/forms/CoursesByModalityAndAreaReportForm.vue'),
                /* no children */
              },
              {
                path: 'ExecutiveReportForm',
                name: 'itineraries-reports-forms-executive-report-form',
                component: () => import('/app/src/pages/itineraries/reports/forms/ExecutiveReportForm.vue'),
                /* no children */
              },
              {
                path: 'ProfileExpirationReportForm',
                name: 'itineraries-reports-forms-profile-expiration-report-form',
                component: () => import('/app/src/pages/itineraries/reports/forms/ProfileExpirationReportForm.vue'),
                /* no children */
              },
              {
                path: 'TechAreaReportForm',
                name: 'itineraries-reports-forms-tech-area-report-form',
                component: () => import('/app/src/pages/itineraries/reports/forms/TechAreaReportForm.vue'),
                /* no children */
              },
              {
                path: 'VisibleFormFields',
                name: 'itineraries-reports-forms-visible-form-fields',
                component: () => import('/app/src/pages/itineraries/reports/forms/VisibleFormFields.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'ReportsCarousel',
            name: 'itineraries-reports-reports-carousel',
            component: () => import('/app/src/pages/itineraries/reports/ReportsCarousel.vue'),
            /* no children */
          },
          {
            path: 'ReportsTable',
            name: 'itineraries-reports-reports-table',
            component: () => import('/app/src/pages/itineraries/reports/ReportsTable.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'updates',
        /* internal name: 'itineraries-updates' */
        /* no component */
        children: [
          {
            path: '',
            name: 'itineraries-updates',
            component: () => import('/app/src/pages/itineraries/updates/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'itineraries-updates-id',
            component: () => import('/app/src/pages/itineraries/updates/[id].vue'),
            /* no children */
          },
          {
            path: 'committee',
            /* internal name: 'itineraries-updates-committee' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'itineraries-updates-committee-id',
                component: () => import('/app/src/pages/itineraries/updates/committee/[id].vue'),
                /* no children */
              },
  _mergeRouteRecord(
              {
                path: 'comparison',
                name: 'itineraries-updates-committee-comparison',
                component: () => import('/app/src/pages/itineraries/updates/committee/comparison.vue'),
                /* no children */
              },
  _definePage_default_4
  ),
              {
                path: 'course',
                name: 'itineraries-updates-committee-course',
                component: () => import('/app/src/pages/itineraries/updates/committee/course.vue'),
                /* no children */
              },
              {
                path: 'PreliminaryReportDrawer',
                name: 'itineraries-updates-committee-preliminary-report-drawer',
                component: () => import('/app/src/pages/itineraries/updates/committee/PreliminaryReportDrawer.vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/app/src/pages/login.vue'),
    /* no children */
  },
  _definePage_default_5
  ),
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/app/src/pages/not-authorized.vue'),
    /* no children */
    meta: {
      "layout": "blank",
      "action": "read",
      "subject": "Auth"
    }
  },
  _definePage_default_6
  ),
  {
    path: '/regional',
    /* internal name: 'regional' */
    /* no component */
    children: [
      {
        path: 'areas',
        /* internal name: 'regional-areas' */
        /* no component */
        children: [
          {
            path: '',
            name: 'regional-areas',
            component: () => import('/app/src/pages/regional/areas/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'regional-areas-id',
            component: () => import('/app/src/pages/regional/areas/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'course-plan-cover',
        /* internal name: 'regional-course-plan-cover' */
        /* no component */
        children: [
          {
            path: '',
            name: 'regional-course-plan-cover',
            component: () => import('/app/src/pages/regional/course-plan-cover/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'updates',
        /* internal name: 'regional-updates' */
        /* no component */
        children: [
          {
            path: '',
            name: 'regional-updates',
            component: () => import('/app/src/pages/regional/updates/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'regional-updates-id',
            component: () => import('/app/src/pages/regional/updates/[id].vue'),
            /* no children */
          },
          {
            path: 'committee',
            /* internal name: 'regional-updates-committee' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'regional-updates-committee-id',
                component: () => import('/app/src/pages/regional/updates/committee/[id].vue'),
                /* no children */
                meta: {
                  "navActiveLink": "regional-updates"
                }
              },
              {
                path: 'course',
                name: 'regional-updates-committee-course',
                component: () => import('/app/src/pages/regional/updates/committee/course.vue'),
                /* no children */
                meta: {
                  "navActiveLink": "regional-updates"
                }
              }
            ],
          }
        ],
      }
    ],
  }
]
